import { createFileRoute } from "@tanstack/react-router";
import { UploadSeite } from "@/components/UploadSeite";

/*
 * `/admin/upload` — Inventur-Mappe hochladen, prüfen, anwenden.
 *
 * Der Unterstrich in `admin_.upload.tsx` löst diese Route aus `admin.tsx`
 * heraus: sie liegt PFADLICH unter `/admin`, aber nicht in dessen Layout. Ohne
 * ihn stünde die Landeseite über jeder Upload-Ansicht, und `/admin` bräuchte
 * eine eigene Index-Route.
 *
 * Kein `loader`: die Sicht führt einen mehrstufigen Ablauf mit Zustand auf dem
 * Server (Vormerkung → bestätigen/verwerfen). Ein Loader würde nur den ersten
 * Schritt holen und müsste den Rest ohnehin der Komponente lassen.
 */
export const Route = createFileRoute("/admin_/upload")({
  component: UploadSeite,
});
